import { FormattedMessage } from "react-intl";
import Header from "components/layout/Header";
import ButtonLink from "components/common/ButtonLink";
import { ROUTE_PATHS } from "const/paths";
import { useTableQueryParams } from "hooks/useTableQueryParams";
import { VenueUser } from "@ticketingplatform/api/dist/venueUser/fragments/__generated__/VenueUser";

import UserTable from "../../Users/UserList/partials/UserTable";

import { useVenueUserActionColumns, useVenueUserList } from "./hooks";

const VenueUserList = () => {
  const additionalColumns = useVenueUserActionColumns();
  const [{ sortOrder }] = useTableQueryParams<VenueUser>();
  const { dataSource, loading, pagination, onChange } = useVenueUserList();

  return (
    <>
      <Header>
        <ButtonLink type="primary" to={ROUTE_PATHS.SettingsVenueUserCreate}>
          <FormattedMessage defaultMessage="Add new user" />
        </ButtonLink>
      </Header>
      <UserTable
        {...{
          dataSource,
          loading,
          pagination,
          onChange,
          sortOrder,
          additionalColumns,
        }}
      />
    </>
  );
};

export default VenueUserList;
